// libs
import { SerializedStyles } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

//icons
import RightArrow from '@nykaa/ui-components/Icons/arrow-right';

import { keyframes } from '@emotion/core';

const rollUp = keyframes`
0%{
  bottom: -4px;
}
10%{
  bottom: 0px;
  opacity: 1;
}
40%{
  bottom: 0px;
  opacity: 1;
}
50%{
  bottom: 8px;
  opacity: 0;
}
`;

const rollUp2 = keyframes`
40%{
  bottom: -4px;
  opacity: 0;
}
50%{
  bottom: 0px;
  opacity: 1;
}
90%{
  bottom: 0px;
  opacity: 1;
}
100%{
  bottom: 8px;
  opacity: 0;
}
`;

const hideNudge = keyframes`
from{
  bottom: 0px;
  opacity: 1;
}
to{
  bottom: 8px;
  opacity: 0;
}
`;

export const Container = styled.div<{ cssProps?: SerializedStyles | SerializedStyles[] }>`
  height: 46px;
  min-width: 170px;
  position: relative;
  ${({ theme }) => theme.typography.bodyMedium};

  ${({ cssProps }) => cssProps && cssProps};

  margin-top: ${({ theme }) => theme.spacing.spacing100};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: auto;
  }
`;

export const Amount = styled.span`
  ${({ theme }) => theme.typography.titleLarge};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${({ theme }) => `-${theme.spacing.spacing20}`};

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.titleMedium};
    margin-bottom: 0;
  }
`;

export const OriginalPrice = styled.span`
  margin: ${({ theme }) => `0 ${theme.spacing.spacing40} 0 0`};
`;

export const Label = styled.div`
  height: 16px;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyMedium};
  margin-top: ${({ theme }) => theme.spacing.spacing10};
  display: flex;
  align-items: baseline;

  .sub {
    ${({ theme }) => theme.typography.bodySmall};
    vertical-align: top;
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 24px;
    margin-top: ${({ theme }) => theme.spacing.spacing20};
    ${({ theme }) => theme.typography.bodyLarge};

    .sub {
      ${({ theme }) => theme.typography.bodyMedium};
      margin-left: 0;
      vertical-align: unset;
    }
  }
`;

export const Currency = styled.span`
  margin-right: 1px;
  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-right: 0;
  }
  text-decoration: none;
`;

export const Discount = styled.span`
  ${({ theme }) => theme.typography.type201};
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.positive};
  position: relative;
  vertical-align: baseline;

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
    margin-left: ${({ theme }) => theme.spacing.spacing20};
    vertical-align: baseline;
  }
`;

export const LineThroughPrice = styled.span`
  text-decoration: line-through;
`;

export const DownArrow = styled(RightArrow)`
  transform: rotate(90deg);
  margin-left: ${({ theme }) => theme.spacing.spacing10};
  position: relative;
  bottom: -1px;
`;

export const UrgencyTag = styled.div<{ color: string; priceAnimation: boolean }>`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ color }) => color};
  opacity: 0;
  animation: ${rollUp} 6.2s 2s forwards 5;
  bottom: -8px;
  margin-top: ${({ theme }) => theme.spacing.spacing10};
`;

export const UrgencyContainer = styled.div`
  display: inline-block;
  height: 16px;
  width: 146px;
  margin-top: ${({ theme }) => theme.spacing.spacing10};
  .price-label,
  .mrp-label {
    animation: ${hideNudge} 0.6s 1.5s forwards ease-in 1, ${rollUp2} 6.2s 2.2s forwards ease-in 4.75;
    opacity: 1;
  }
  .sticky-promo {
    padding-left: 0;
    top: -${({ theme }) => theme.spacing.spacing10};
  }
  & > div {
    margin-top: 0;
    position: absolute;
  }
`;

export const MRP = styled.span`
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;
